(() => {
  const state = window.__eimeleLoadingScreen;
  const screen = document.getElementById('EimeleLoadingScreen');

  if (!state?.shouldPlay || !screen) return;

  const counter = screen.querySelector('.eimele-loading-screen__counter');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const timers = [];
  let counterTimer;
  let finished = false;

  const schedule = (callback, delay) => {
    timers.push(window.setTimeout(callback, delay));
  };

  const cleanup = () => {
    if (finished) return;
    finished = true;
    timers.forEach(window.clearTimeout);
    window.clearTimeout(counterTimer);
    window.clearTimeout(window.__eimeleLoadingFailSafe);

    document.documentElement.classList.remove('eimele-loading-pending', 'eimele-loading-active');

    if (!state.forcePreview) {
      try {
        window.sessionStorage.setItem(state.key, '1');
      } catch (error) {
        // Storage can be unavailable in strict privacy modes; the animation can safely replay.
      }
    }

    screen.remove();
  };

  const exit = () => {
    if (finished || screen.classList.contains('is-exiting')) return;
    screen.classList.add('is-exiting');
    schedule(cleanup, reducedMotion ? 180 : 960);
  };

  const exitWhenReady = () => {
    if (document.readyState === 'complete') {
      exit();
      return;
    }

    window.addEventListener('load', exit, { once: true });
    schedule(exit, 1500);
  };

  document.documentElement.classList.remove('eimele-loading-pending');
  document.documentElement.classList.add('eimele-loading-active');

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) cleanup();
  });

  if (reducedMotion) {
    screen.classList.add('is-logo');
    schedule(exit, 220);
    return;
  }

  window.requestAnimationFrame(() => screen.classList.add('is-counting'));
  let number = 1;
  const advanceCounter = () => {
    if (finished || !screen.isConnected) {
      return;
    }

    number += 1;
    if (counter) counter.textContent = String(number).padStart(2, '0');

    if (number === 99) {
      schedule(() => screen.classList.add('is-logo'), 280);
      schedule(exitWhenReady, 1100);
      return;
    }

    const distanceFromMiddle = Math.abs((number - 50) / 49);
    counterTimer = window.setTimeout(advanceCounter, Math.round(8 + 24 * distanceFromMiddle ** 2));
  };
  counterTimer = window.setTimeout(advanceCounter, 32);
})();
